export default {
  id: 'blank', label: 'Blank — No Header/Footer',
  includeChrome: false,
  build: (handler) => [handler],
  css: '.html-page-layout{width:100%;min-width:0;}',
};
